import React from "react";
import { useNavigate } from "react-router-dom";

import styles from "./dashboard.module.scss";

import payroll from "assets/images/dashboard/payrollreports.png";
import managedeductions from "assets/images/dashboard/managededuction.png";
import dollorinhand from "assets/images/dashboard/dollorinhand.png";
import manageemployee from "assets/images/dashboard/managecompany.png";
import timewatch from "assets/images/dashboard/timewatch.png";
import managecompany from "assets/images/dashboard/managecompany.png";
import receivepayment from "assets/images/dashboard/receivepayment.png";
import payrollreports from "assets/images/dashboard/payrollreports.png";
import sorter from "assets/images/icon/sorter.png";
import filtersearch from "assets/images/icon/filter-search.png";
import filter from "assets/images/icon/filter-icon.png";
import PayrollsTable from "./PayrollsTable";
import DashboardCharts from "./DashboardCharts";
import { useQuery } from "@tanstack/react-query";
import { getCompany } from "services/company";

function Dashboard() {
  const navigate = useNavigate();
  const { data } = useQuery({ queryKey: ["company"], queryFn: getCompany });

  console.log("data", data);

  return (
    <div
      className="content"
      style={{ padding: "16px 24px 16px 16px", backgroundColor: "#F8F9FA" }}
    >
      <div className="breadcrumb-section ms-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Dashboard
            </li>
          </ol>
        </nav>
        <h2 className="main-title mt-1">Dashboard</h2>
      </div>
      <div className="row mt-5">
        <div className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card">
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              {/* <img src={payroll} alt="payroll" /> */}
              {/* <div className={styles.iconContainer}> */}
              <img src={dollorinhand} alt="dollorinhand" />

              {/* <OnhandDollar /> */}
              {/* </div> */}
              <h2 className="card-title">Start New Payroll</h2>
            </div>
          </div>
        </div>
        <div
          className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card"
          onClick={() => navigate("/deductions")}
        >
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              <img src={managedeductions} alt="managedeductions" />
              <h2 className="card-title">Manage Deductions</h2>
            </div>
          </div>
        </div>
        <div
          className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card"
          onClick={() => navigate("/employees")}
        >
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              <img src={manageemployee} alt="manageemployee" />
              <h2 className="card-title">Manage Employee</h2>
            </div>
          </div>
        </div>
        <div
          className="col-xxl-3 col-lg-4 mb-4  dashboard-details-card"
          onClick={() => navigate("/dashboard/payroll-time-keeping")}
        >
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              <img src={timewatch} alt="timewatch" />
              <h2 className="card-title">Time & Attendance</h2>
            </div>
          </div>
        </div>
        <div
          className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card"
          onClick={() => navigate("/contractor")}
        >
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              <img src={manageemployee} alt="manageemployee" />
              <h2 className="card-title">Manage Contractor</h2>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card">
          <div className="dashboard-details">
            <div
              className="d-flex align-items-center gap-3"
              onClick={() => navigate("/dashboard/manage-company")}
            >
              <img src={managecompany} alt="managecompany" />
              <h2 className="card-title">Manage Company</h2>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card">
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              <img src={receivepayment} alt="receivepayment" />
              <h2 className="card-title">Receive Payment</h2>
            </div>
          </div>
        </div>
        <div
          className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card"
          onClick={() => navigate("/reports/all-reports")}
        >
          <div className="dashboard-details">
            <div className="d-flex align-items-center gap-3">
              <img src={payrollreports} alt="payrollreports" />
              <h2 className="card-title">Payroll Reports</h2>
            </div>
          </div>
        </div>
      </div>
      <DashboardCharts />
      <div className="table-section mt-3">
        <div className="filter-section d-flex align-items-center justify-content-between">
          <div>
            <form>
              <div className="search-input">
                <input type="text" placeholder="Search" />
                <img
                  className="search-icon"
                  src={filtersearch}
                  alt="filtersearch"
                />
              </div>
            </form>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center gap-3">
              <div className="active-status"></div>
              <p className="amendment-title m-0">Show Amendment Payrolls</p>
            </div>
            <div className="filter-box d-flex align-items-center gap-3">
              <img className="search-icon" src={filter} alt="filter" />
              <p className="amendment-title filter-payroll m-0">
                Filter Payroll
              </p>
            </div>
          </div>
        </div>
        {/* <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Payday <img src={sorter} className='me-2' alt="sorter" /></th>
                            <th scope="col">Pay Period <img src={sorter} className='me-2' alt="sorter" /></th>
                            <th scope="col">Processing Period <img src={sorter} className='me-2' alt="sorter" />
                            </th>
                            <th scope="col">Processing Period <img src={sorter} className='me-2' alt="sorter" />
                            </th>
                            <th scope="col">Status <img src={sorter} className='me-2' alt="sorter" /></th>
                            <th scope="col">Voided <img src={sorter} className='me-2' alt="sorter" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className='ping-bg'>
                            <td>Fri, Feb 14, 2025</td>
                            <td>Feb 08, 2025 - Feb 14,2025</td>
                            <td>Three-Day</td>
                            <td>Regular</td>
                            <td>
                                <button className='draft-button'>Draft</button>
                            </td>
                            <td>
                                <button className='not-void-button'>Not Void</button>
                            </td>
                        </tr>
                        <tr className='gray-bg'>
                            <td>Fri, Feb 14, 2025</td>
                            <td>Feb 08, 2025 - Feb 14,2025</td>
                            <td>Three-Day</td>
                            <td>Regular</td>
                            <td>
                                <button className='draft-button'>Draft</button>
                            </td>
                            <td>
                                <button className='not-void-button'>Not Void</button>
                            </td>
                        </tr>
                    </tbody>
                </table> */}
        <PayrollsTable />
      </div>
    </div>
  );
}

export default Dashboard;
